import { StyledSearch } from '../Header.style';
import { useDebounceCallback } from '@react-hook/debounce';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import { VALIDATION_RULES } from 'common/validations/validation.rules';
import { SearchInputWithValidation } from 'common/validations/input-components';

const SearchKeyword = ({ value, onChange }) => {
  const trackAmplitudeOnSearch = useDebounceCallback(() => {
    TrackingService.logEvent(TRACKING.EVENTS.FILTER, {
      page: TRACKING.PAGES.PROJECT_PROGRESSION,
      filter_name:
        TRACKING.CLICK.PROJECT_PROGRESSION.PROGRESSION_TABLE.FILTERS
          .SEARCH_INPUT
    });
  }, 500);

  return (
    <StyledSearch>
      <SearchInputWithValidation
        width='95%'
        height='3rem'
        placeholder='Type name'
        value={value}
        onChange={value => {
          onChange(value);
          trackAmplitudeOnSearch();
        }}
        validationRules={[VALIDATION_RULES.minLength(2)]}
      />
    </StyledSearch>
  );
};

export default SearchKeyword;
